// Mirrors com.azry.rs.portal.core.model.status.Status on the server.
//
// The tag shows the front status (StatusGeneral.name) the server sends, and several
// internal statuses share one front status - the rs.ge pipeline steps all read
// "მუშავდება", ERROR and EXCEPTION both read "შეცდომა". So the colour follows the front
// status, not the internal one: rows that say the same thing look the same.
// The groups below match the status pairs in the server's data export.
// The colours live in App.css as .status-tag-<front status>.
const FRONT_STATUS: Record<string, string> = {
  DRAFT: 'draft',
  READY: 'waiting',

  // rs.ge pipeline. RS_REG_APP is its own front status ("რეგისტრაცია"); the rest,
  // including the retired stages and the address change, read "მუშავდება".
  STARTED: 'processing',
  RS_ORG_NAME: 'processing',
  RS_SAVE_ADDRESS: 'processing',
  RS_GE_STAGE1: 'processing',
  RS_GE_STAGE2: 'processing',
  RS_WS: 'processing',
  CHANGE_ADDRESS: 'processing',
  RS_REG_APP: 'registration',

  FINISHED: 'finished',
  DEREGISTERED: 'deregistered',

  ERROR: 'error',
  EXCEPTION: 'error',
  CHANGE_ADDRESS_ERROR: 'error',
  DEREGISTER_ERROR: 'deregister-error',
};

const ERROR_STATUSES = new Set(['ERROR', 'EXCEPTION', 'DEREGISTER_ERROR', 'CHANGE_ADDRESS_ERROR']);

export function isErrorStatus(statusId?: string): boolean {
  return !!statusId && ERROR_STATUSES.has(statusId);
}

/**
 * Props for the status <Tag>. A status the server added but we have not grouped yet gets
 * no class, so it falls back to the theme default and is visible as unmapped.
 */
export function statusTagProps(statusId?: string) {
  const front = statusId ? FRONT_STATUS[statusId] : undefined;
  return {
    className: front ? `status-tag status-tag-${front}` : undefined,
  };
}
